import axios from "./index";

class OrderApi {

  static Get = (search = null,page) => {
    if (search.length) {
      return axios.get(`orders`,{
        params: {
          worder_id : search,
          page,
        }
      });
    }
    return axios.get(`orders`,{
      params: {
        page,
      }
    });
  };
  static GetDetails = (id) => {
    return axios.get(`orders/${id}`);
  };

  static Recheck = (id) => {
    return axios.get(`orders/${id}/recheck`);
  };

  static MarkAsDelivered = (orderId) => {
    return axios.patch(`orders/${orderId}/delivered`);
  };

}

let base = "";

export default OrderApi;
